import React, { useState, useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import LanguageSwitcher from "../../components/blocks/LanguageSwitcher";
import { useAuth } from "../../context/AuthContext";
import { Link } from "gatsby";
import { linkResolver } from "../../utilities/linkResolver";
import translations from "../../utilities/translations";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import phone from "../../images/phone.svg";
import mail from "../../images/mail.svg";

const NavbarDesktop = ({ logo, settings, menu, contactInfo, pageData }) => {
  // console.log(menu);
  const { handleLogout, handleLogin, user, currentLanguage } = useAuth();
  const [buttonHref, setButtonHref] = useState("/syndesi-eggrafi/");
  const [buttonText, setButtonText] = useState(
    translations("login-register", currentLanguage)
  );

  // console.log(settings, pageData);

  useEffect(() => {
    if (user === null) {
      setButtonHref("/syndesi-eggrafi/");
      setButtonText(translations("login-register", currentLanguage));
    } else {
      setButtonHref("/");
      setButtonText(translations("logout", currentLanguage));
    }
  }, [user, currentLanguage]);

  return (
    <Navbar expand="lg" className="d-none d-lg-block">
      <Container className="max-container d-flex flex-column">
        <div className="topbar justify-content-between w-100 d-none d-md-flex">
          <div>
            {contactInfo[0].contactInfo?.map((item, index) => (
              <React.Fragment key={index}>
                <>
                  {index === 0 && (
                    <img src={phone} alt="phone icon" className="me-2" />
                  )}
                  <a href={item?.phoneUrl} className="me-2 info-item">
                    {item?.phone}
                  </a>
                  {index === 0 && <span className="me-2">|</span>}
                </>

                {item.email && (
                  <>
                    <img src={mail} alt="mail icon" className="me-2 ms-3" />
                    <a href={item?.emailUrl} className="me-3 info-item">
                      {item?.email}
                    </a>
                  </>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className="buttons d-flex align-items-center">
            <Button
              className="px-4 btn-brown me-2"
              href={buttonHref}
              onClick={user !== null ? handleLogout : handleLogin}
            >
              {buttonText}
            </Button>

            <LanguageSwitcher pageData={pageData} />
          </div>
        </div>
        <hr className="d-none d-md-block" />
        <div className="d-flex w-100 mb-3">
          <Navbar.Brand href={currentLanguage === "el-GR" ? "/" : "/en"}>
            <img src={logo?.localFile?.publicURL} alt="xerolivado logo" />
          </Navbar.Brand>

          {/* {activeDocMeta.type === "homepage" && (
            <h1 className="visually-hidden">
              {settings?.data?.site_title || "Elata Xiroliavadou"}
            </h1>
          )} */}

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {menu.map((item, index) => {
                return (
                  <>
                    {/* <Nav.Link
                      key={index}
                      href={`/${item?.page?.slug}/`}
                      className="ms-3"
                    >
                      {item.menuItem}
                    </Nav.Link> */}
                    <Link
                      className="ms-3 nav-link"
                      to={linkResolver(item?.page)}
                      activeClassName="active"
                    >
                      {item.menuItem}
                    </Link>
                  </>
                );
              })}
            </Nav>
          </Navbar.Collapse>
        </div>
      </Container>
    </Navbar>
  );
};

export default NavbarDesktop;
